export default __webpack_public_path__ + "static/media/FONDO_GARBANZO.b439190c.png";